import StepCodeTag from "./StepCodeTag";
import "./PosFieldLabel.css";

export default function PosFieldLabel({ code, children, as: Tag = "label", className = "" }) {
    return (
        <Tag className={`pos-field-label ${className}`.trim()}>
            {code && <StepCodeTag code={code} />}
            <span>{children}</span>
        </Tag>
    );
}
